module.exports = __webpack_public_path__ + "static/media/Insights.9e0864ef.png";